export enum ShortcutTypeEnum {
  CUSTOM = 1,
  MENU = 2,
}
